import { Collapse, Stack } from "@mui/material";
import { useState } from "react";
import useLocales from "src/hooks/useLocales";

import ColorSelector from "../components/ColorSelector/ColorSelector";
import TitlteColapse from "../components/TitlteColapse";

export default function ErrorSection() {
	const [isColapsed, setIsColapsed] = useState(false);
	const { translate } = useLocales();
	return (
		<Stack sx={{ mt: 4 }} gap={2}>
			<TitlteColapse
				title={translate("customization.errors")}
				onClick={() => setIsColapsed(!isColapsed)}
				isColapsed={isColapsed}
			/>
			<Collapse in={isColapsed} timeout='auto' unmountOnExit>
				<Stack gap={2}>
					<ColorSelector title={translate("customization.error_icon")} name={"mainError"} />
					<ColorSelector title={translate("customization.error_background")} name={"lightError"} />
					<ColorSelector title={translate("customization.error_text")} name={"darkError"} />
				</Stack>
			</Collapse>
		</Stack>
	);
}
